import { render } from "./simplemap.vue?vue&type=template&id=7ece6742"
import script from "./simplemap.vue?vue&type=script&lang=js"
export * from "./simplemap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__